// extracted by mini-css-extract-plugin
module.exports = {"viewports":"\"../../../../../viewports.css\"","desktop":"1024px","tabs":"tabs_tabs__m5ygR"};